var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeSnekQuery } from "snek-query";
import { Query, Mutation } from "./schema.generated";
export const sq = makeSnekQuery({ Query, Mutation }, {
    apiURL: "https://services.snek.at/graphql",
    middlewares: [
        ({ context }) => {
            const tokenPair = getTokenPair();
            if (!tokenPair) {
                return context;
            }
            return Object.assign(Object.assign({}, context), { headers: Object.assign(Object.assign({}, context.headers), { Authorization: `Bearer ${tokenPair.accessToken}` }) });
        },
    ],
    onError: ({ graphQLErrors, forward, operation }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const logout = () => {
            setTokenPair(null);
            if (typeof window !== "undefined") {
                window.location.reload();
            }
        };
        if (!graphQLErrors) {
            return;
        }
        const tokenPair = getTokenPair();
        if (!tokenPair) {
            return;
        }
        for (const err of graphQLErrors) {
            if (((_a = err.extensions) === null || _a === void 0 ? void 0 : _a.code) === "TOKEN_EXPIRED") {
                const [newTokens, errors] = yield sq.mutate((Mutation) => {
                    const refresh = Mutation.userRefresh({
                        refreshToken: tokenPair.refreshToken,
                        accessToken: tokenPair.accessToken,
                    }).tokenPair;
                    return {
                        accessToken: refresh.accessToken,
                        refreshToken: refresh.refreshToken,
                    };
                });
                if (errors) {
                    logout();
                    return;
                }
                setTokenPair(newTokens, true);
                operation.setContext({
                    headers: Object.assign(Object.assign({}, operation.getContext().headers), { Authorization: `Bearer ${newTokens.accessToken}` }),
                });
                return forward(operation);
            }
            else if (((_b = err.extensions) === null || _b === void 0 ? void 0 : _b.code) === "REFRESH_TOKEN_EXPIRED") {
                logout();
                return;
            }
        }
    }),
});
const TOKEN_PAIR_KEY = "@sq-origin/tokenPair";
export const setTokenPair = (tokenPair, isSession) => {
    if (!tokenPair) {
        // remove key from both local and session storage
        sessionStorage.removeItem(TOKEN_PAIR_KEY);
        localStorage.removeItem(TOKEN_PAIR_KEY);
    }
    else {
        const storage = isSession ? sessionStorage : localStorage;
        storage.setItem(TOKEN_PAIR_KEY, JSON.stringify(tokenPair));
    }
};
export const getTokenPair = () => {
    // lookup key in both local and session storage
    const tokenPair = sessionStorage.getItem(TOKEN_PAIR_KEY) ||
        localStorage.getItem(TOKEN_PAIR_KEY);
    if (!tokenPair) {
        return null;
    }
    return JSON.parse(tokenPair);
};
/**
 * Checks if the user is logged in via session storage.
 * It does not check if the user is logged in at all.
 *
 * So if the user is logged in via local storage, this function will return false.
 * To check if the user is logged in, use the getTokenPair function.
 *
 * @returns {boolean} true if the user is logged in via session storage
 */
export const isSession = () => {
    return !!sessionStorage.getItem(TOKEN_PAIR_KEY);
};
